'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _next = require('@alifd/next');

var _lodash = require('lodash');

var _vuFusionField = require('../common/vu-fusion-field');

var _vuFusionField2 = _interopRequireDefault(_vuFusionField);

var _ossUploadHelper = require('../common/oss-upload-helper');

require('./view.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var DEFAULT_IMG_FILETYPES = ['image/png', 'image/jpg', 'image/jpeg', 'image/bmp', 'image/gif', '.png', '.jpg', '.jpeg', '.bmp', '.gif'];
var Attachment = (_temp2 = _class = function (_Field) {
  _inherits(Attachment, _Field);

  function Attachment() {
    var _temp, _this, _ret;

    _classCallCheck(this, Attachment);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Field.call.apply(_Field, [this].concat(args))), _this), _this.onSuccess = function (file, value) {
      (0, _ossUploadHelper.registerFile)(file.name, file.originFileObj && file.originFileObj.fileKey);
      if (/^image/.test(file.type)) {
        (0, _ossUploadHelper.getImageDimensions)(file.imgURL).then(function (dimension) {
          _extends(file, dimension);
          _this.onChange(value);
        });
      }
    }, _this.onChange = function (value) {
      var onChange = _this.props.onChange;

      onChange({ value: _this.formatOut(value) });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Attachment.prototype.getProps = function getProps() {
    return _extends({}, this.props, {
      fieldClassName: 'vc-attachment'
    });
  };

  // onError = file => {
  //   const { name } = file;
  //   Message.warning(`文件 ${name} 上传失败`);
  // };

  Attachment.prototype.renderView = function renderView() {
    return this.renderControl(true);
  };

  Attachment.prototype.renderControl = function renderControl() {
    var isDetail = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var commonProps = this.getControlProps();
    var behavior = this.getBehavior();

    var _props = this.props,
        isOnlyImg = _props.isOnlyImg,
        button = _props.button,
        limit = _props.limit,
        templateUrl = _props.templateUrl,
        templateButton = _props.templateButton,
        global = _props.global;

    var accept = this.accept ? this.accept : isOnlyImg ? DEFAULT_IMG_FILETYPES.join(',') : '';
    var uploadProps = _extends({}, commonProps, {
      isPreview: commonProps.readOnly,
      listType: 'text', // isOnlyImg ? 'card' : 'text',
      accept: accept,
      multiple: false,
      limit: limit > 0 ? limit : Infinity,
      beforeUpload: function beforeUpload(file, options) {
        if ((0, _ossUploadHelper.isFileAccept)(file.name, accept)) {
          return (0, _ossUploadHelper.beforeUpload)(file, options, _extends({}, (0, _lodash.get)(global, 'formOptions', {}), {
            sceneName: 'FORM_ATTACHMENT'
          }));
        } else {
          _next.Message.error('不允许上传该文件类型！');
          return false;
        }
      },
      formatter: _ossUploadHelper.uploadResultFormatter,
      onSuccess: this.onSuccess,
      onChange: this.onChange
      // onError: this.onError
    });
    return uploadProps.listType === 'card' ? _react2.default.createElement(_next.Upload.Card, uploadProps) : _react2.default.createElement(
      _react.Fragment,
      null,
      _react2.default.createElement(
        _next.Upload,
        uploadProps,
        _react2.default.createElement(
          _next.Button,
          { type: 'secondary' },
          button
        )
      ),
      templateUrl && behavior === 'NORMAL' && !isDetail && _react2.default.createElement(
        'a',
        {
          href: templateUrl,
          target: '_blank',
          title: templateButton,
          download: true,
          style: {
            left: 120,
            position: 'absolute',
            top: 7,
            whiteSpace: 'nowrap',
            maxWidth: '150px',
            textOverflow: 'ellipsis',
            overflow: 'hidden'
          }
        },
        templateButton
      )
    );
  };

  _createClass(Attachment, [{
    key: 'accept',
    get: function get() {
      var accept = this.props.accept;

      if ((0, _lodash.isString)(accept) && !(0, _lodash.isEmpty)(accept) && accept.indexOf(',') > -1) {
        return accept.split(',').map(function (item) {
          return item.startsWith('.') || item.includes('/') ? item : '.' + item;
        }).join(',');
      }
      return accept;
    }
  }]);

  return Attachment;
}(_vuFusionField2.default), _class.displayName = 'Attachment', _class.defaultProps = _extends({}, _vuFusionField2.default.defaultProps, {
  button: '选择文件',
  templateButton: '下载样表'
}), _class.validators = {
  imgMinHeight: {
    valid: function valid(value, param) {
      return !value || !value.some(function (item) {
        return item && item.height && item.height < param;
      });
    }
  },
  imgMaxHeight: {
    valid: function valid(value, param) {
      return !value || !value.some(function (item) {
        return item && item.height && item.height > param;
      });
    }
  },
  imgHeight: {
    valid: function valid(value, param) {
      return !value || !value.some(function (item) {
        return item && item.height && item.height !== param;
      });
    }
  },
  imgMinWidth: {
    valid: function valid(value, param) {
      return !value || !value.some(function (item) {
        return item && item.width && item.width < param;
      });
    }
  },
  imgMaxWidth: {
    valid: function valid(value, param) {
      return !value || !value.some(function (item) {
        return item && item.width && item.width > param;
      });
    }
  },
  imgWidth: {
    valid: function valid(value, param) {
      return !value || !value.some(function (item) {
        return item && item.width && item.width !== param;
      });
    }
  }
}, _temp2);
exports.default = Attachment;
module.exports = exports['default'];